import React, {useState, useEffect} from "react";
// import {SetMetaData} from './../../helper/page-title';
import {post_api_call,
        error_api_call,
      } from './../../actions/action-creators/common';
// import { alertResponseMessage } from "../../actions/action-creators/response";
import {LoaderMedium} from './../../components/loader';
import { copyClipBoard } from './../../helper/custom-function';
import ShareIconsComp from '../../components/form/share';

function DashAffiliate(){
    // SetMetaData("Manage Pinned Students", "", "");
    const [isLoading, setIsLoading] = useState(true);
    const [referralData, setReferralData] = useState({'referral_code': ''});
    //Get Data for Dropdown
    const fetchMasterData = async() => {
      try{
        const apiData = await post_api_call('dashboard', {});
        if(apiData.status === 200){
          setReferralData({referral_code: `${process.env.REACT_APP_CLIENT_DOMAIN}?a=${apiData.data.referral_details.referral_code}`});
          setIsLoading(false);
        }
      }catch(e){
        error_api_call({error: `admin|screen|dashboard|affiliate|fetchMasterData|${e}`});
      }
    }
    useEffect(() => {
      //Initial API Data
      fetchMasterData();
    }, []);

    return (
        isLoading
        ?
            <LoaderMedium />
        :
        <>
        {referralData.referral_code !== '' && (
        <>
        <h3 className="page-title text-center mb-3">Your Affiliate Link</h3>
        <div className="row">
            <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
                <div className="card-body border border-1 border-success p-4">
                    <div className="d-flex justify-content-center">
                    <div className="d-flex">
                        <div className="alert alert-secondary" role="alert">
                        {referralData.referral_code}
                        </div>
                        <button
                            className="btn btn- btn-info btn-social-icon"
                            onClick={(e) => copyClipBoard(e, referralData.referral_code, 'Link')}
                        >
                            Copy
                        </button>
                    </div>
                    </div>
                    {/* Share */}
                    <p className="text-center mb-0 mt-2">
                        Share:&nbsp;
                        <ShareIconsComp
                            title={`Ready to unlock bigger opportunities? IFSPD Europe's PORT transforms your achievements and certificates into a captivating digital portfolio—while EVA expertly guides your future—career choices, college applications and personal growth.`}
                            link={`${referralData.referral_code.replace(/^https?:\/\//, '')}`}
                            subject={`Unlock bigger Opportunities: Transforms your achievements and certificates into a digital portfolio`}
                            // showAsItIs={true}
                        />
                    </p>
                </div>
            </div>
            </div>
        </div>
        </>
        )}
        </>
    )    
}

export default DashAffiliate;